import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import ProBadge from 'components/common/ProBadge'
import { startProCheckout } from '../../../proCheckout'
import ColorsIcon from '../../common/icons/ColorsIcon'

// The "Color" action in the shape/boundary panes.
// With a status and statusColorType 'fill', the status colour is the whole fill, so the item's own
// colour isn't shown anywhere and editing it is locked. In 'outline' mode the status only paints the
// outline (components/map/Geopolygon.jsx) and this colour is the fill, so it stays editable.
// A folder's Color recolours every shape/boundary in it, so it's only pointless (and locked) when all
// of them have a status; a single item is locked when it has one.
const allColoredByStatus = (item) => {
  if (!item.geopolygons) return !!item.status
  const shapes = [...item.geopolygons, ...(item.boundaries || []), ...(item.zipCodeBoundaries || [])]
  return shapes.length > 0 && shapes.every(shape => !!shape.status)
}

const ColorButton = ({ item, uiStore, dataStore, selectionStore, t }) => {
  const isStarter = !!(uiStore.user && uiStore.user.type === 'starter')
  const managedByStatus = dataStore.statusColorType !== 'outline' && allColoredByStatus(item)

  return (
    <button
      // Not `disabled`: disabled buttons get no hover events in some browsers, which hides the title tooltip.
      aria-disabled={managedByStatus || undefined}
      title={managedByStatus ? t('BOUNDARY.COLOR_MANAGED_BY_STATUS', { defaultValue: 'Color is managed by status' }) : undefined}
      className={`color-btn ${isStarter || managedByStatus ? 'item-controls__disabled' : ''}`}
      onClick={(e) => {
        if (managedByStatus) return
        if (isStarter) {
          startProCheckout({ uiStore, t })
          return
        }
        selectionStore.selectColorEdit(e, true)
      }}
    >
      <ColorsIcon width='22' height='22' className='color--btn-icon' />
      <span>{t('GLOBAL.COLOR')}</span>
      {isStarter && <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
    </button>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore', 'selectionStore')(observer(ColorButton)))
